
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iULSi", function(module, exports) {
'use strict';
async function $dc5297e54d948340$export$8134c072fddab6a5(url) {
    try {
        const response = await fetch(url);
        if (response.ok) {
            const data = await response.json();
            return data;
        }
    } catch (error) {
        console.log(`Error: ${error}`);
    }
}

});

parcelRegister("b4xNq", function(module, exports) {

$parcel$export(module.exports, "renderMovies", () => $80fa48a1974db74a$export$1a30573fde3dfc62);
'use strict';
// ital für Darsteller, Dauer, Regie
const $80fa48a1974db74a$export$1a30573fde3dfc62 = (data, page = 1, actorList = 'Darsteller', length = 'Dauer', director = 'Regie')=>{
    const timerStart = Date.now();
    const fragment = document.createDocumentFragment();
    page--;
    const maxItems = 25;
    let start = maxItems * page;
    let end = start + maxItems;
    let paginatedItems = data.slice(start, end);
    paginatedItems.map((ele, i)=>{
        const listItem = document.createElement('li');
        listItem.className = "list-item";
        // create and append image-element
        const imgWrapper = document.createElement('div');
        imgWrapper.className = "image-wrapper";
        listItem.appendChild(imgWrapper);
        if (ele.image) {
            const image = document.createElement('img');
            image.setAttribute('src', `${ele.image}`);
            image.setAttribute('alt', `${ele.title}`);
            image.setAttribute('onerror', `this.onerror=null;this.src='';`);
            image.className = "item-image";
            imgWrapper.appendChild(image);
        }
        // infoContainer
        const infoContainer = document.createElement('div');
        infoContainer.className = "info-container";
        listItem.appendChild(infoContainer);
        // header
        const header = document.createElement('header');
        header.className = 'item-header';
        infoContainer.appendChild(header);
        // screeningDate
        const screeningDate = document.createElement('span');
        screeningDate.textContent = `${ele.screeningDate}, ${ele.screeningTime} Uhr`;
        header.appendChild(screeningDate);
        // name
        const itemTitle = document.createElement('h2');
        itemTitle.textContent = ele.title.toUpperCase();
        itemTitle.style.marginBottom = "0px";
        header.appendChild(itemTitle);
        // country and year
        const countryAndYear = document.createElement('span');
        countryAndYear.textContent = `${ele.country} ${ele.releaseYear}, `;
        header.appendChild(countryAndYear);
        const runtime = document.createElement('span');
        runtime.textContent = `${length}: ${ele.runtime} min, `;
        header.appendChild(runtime);
        // director and version
        const directorAndVersion = document.createElement('strong');
        directorAndVersion.textContent = `${director}: ${ele.director} - ${ele.version}`;
        header.appendChild(directorAndVersion);
        // actorsContainer
        const actorsContainer = document.createElement('div');
        actorsContainer.className = 'actors-container';
        infoContainer.appendChild(actorsContainer);
        // actors
        const actors = document.createElement('span');
        const strong = document.createElement('strong');
        strong.textContent = `${actorList}: `;
        actors.textContent = ele.actors;
        actorsContainer.appendChild(strong);
        actorsContainer.appendChild(actors);
        // Strong Copy Text
        if (ele.subtitle) ele.subtitle.map((p)=>{
            const subtitle = document.createElement('p');
            subtitle.className = "strong-paragraph";
            subtitle.textContent = p;
            infoContainer.appendChild(subtitle);
        });
        // Copy Text
        if (ele.bodycopy) ele.bodycopy.map((p)=>{
            const bodyCopy = document.createElement('p');
            bodyCopy.className = "paragraph";
            bodyCopy.textContent = p;
            infoContainer.appendChild(bodyCopy);
        });
        fragment.appendChild(listItem);
    });
    const duration = Date.now() - timerStart;
    // console.log(`duration: ${duration}`);
    return fragment;
};

});

parcelRequire("iULSi");

var $b4xNq = parcelRequire("b4xNq");
var $cdae745ca2b0c37d$exports = {};
$cdae745ca2b0c37d$exports = JSON.parse('[{"title":"LA GRAZIA","director":"Paolo Sorrentino","country":"Italien","releaseYear":2025,"runtime":131,"version":"OmU","screeningDate":"17.09.2026","readableDate":"2026-09-17","screeningTime":"20:00","actors":"Toni Servillo, Anna Ferzetti, Orlando Cinque, Massimo Venturiello, Milvia Marigliano u.a.","subtitle":["Ein italienischer Staatspr\xe4sident in den letzten Monaten seiner Amtszeit: Mit LA GRAZIA w\xe4hlt Paolo Sorrentino erneut eine Figur der Macht als Projektionsfl\xe4che f\xfcr moralische und existentielle Fragen. Mariano De Santis muss \xfcber ein Sterbehilfegesetz und zwei Begnadigungsantr\xe4ge entscheiden, w\xe4hrend ihn zugleich die Erinnerung an seine verstorbene Frau verfolgt \u2013 ein politisches Drama, das konsequent ins Private kippt."],"bodycopy":["Damit f\xfcgt sich der Film deutlich in Sorrentinos Gesamtwerk ein. Wie schon in IL DIVO (2008) oder LORO (2018) interessiert ihn weniger die politische Analyse als die innere Verfasstheit der M\xe4chtigen: Einsamkeit, Selbstinszenierung und das Bewusstsein von Verg\xe4nglichkeit. Zugleich kn\xfcpft LA GRAZIA an jene melancholische Sch\xf6nheitssuche an, die sp\xe4testens seit LA GRANDE BELLEZZA (2013) sein Kino pr\xe4gt.","Auch formal setzt Sorrentino auf Kontinuit\xe4t: Wieder arbeitet er mit Toni Servillo, seinem langj\xe4hrigen Hauptdarsteller. Als Er\xf6ffnungsfilm der Biennale Cinema 2025 in Venedig markiert LA GRAZIA damit weniger einen Bruch als eine Verdichtung zentraler Sorrentino Motive \u2013 Macht als Buhne und Gewissen als Abgrund."],"image":"La grazia.jpg"},{"title":"LA GRANDE BELLEZZA (DIE GROSSE SCH\xd6NHEIT)","director":"Paolo Sorrentino","country":"Frankreich, Italien","releaseYear":2013,"runtime":147,"version":"OmU","screeningDate":"15.10.2026","readableDate":"2026-10-15","screeningTime":"20:00","actors":"Toni Servillo, Carlo Verdone, Sabrina Ferilli, Carlo Buccirosso, Iaia Forte u. a.","subtitle":["Ein filmischer Strom aus Bildern, Melancholie und existenzieller Sehnsucht entfaltet ein eindringliches Portr\xe4t eines Mannes, der zwischen Glanz und Leere ein Suchender ist. Paolo Sorrentino entwirft ein kaleidoskopisches Panorama Roms, in dem ein gealterter Autor auf brillanten Festen, in verlassenen Gassen und in sinnlosen Begegnungen das fl\xfcchtige Erleben \u201Egro\xdfer Sch\xf6nheit\u201C als m\xf6glichen Sinnspender seines Lebens auslotet."],"bodycopy":["LA GRANDE BELLEZZA setzt sich mit Verg\xe4nglichkeit, Erinnerung und dem st\xe4ndigen Pendeln zwischen \xf6ffentlicher Oberflache und innerer Leere auseinander. Seine opulente Bildsprache und rhythmische Montage verkn\xfcpfen Reflexion und Ironie zu einem visuellen Essay \xfcber Kunst, Leben und verlorene Ideale. In der thematischen Sprache Sorrentinos findet sich ein wiederkehrendes Motiv: das Ringen um Bedeutung in einer Welt zwischen Schein und Sein. Im Vergleich zu seinem neueren Werk LA GRAZIA verschiebt sich der Fokus von der Suche nach Sch\xf6nheit zu Fragen individueller Verantwortung und innerer Einkehr angesichts moralischer Herausforderungen, bleibt aber im Kern der Reflexion \xfcber das menschliche Dasein verpflichtet."],"image":"La grande bellezza.jpg"},{"title":"SOTTO LE NUVOLE (POMPEJI: UNTER DEN WOLKEN)","director":"Gianfranco Rosi","country":"Italien, Frankreich","releaseYear":2025,"runtime":114,"version":"OmU","screeningDate":"19.11.2026","readableDate":"2026-11-19","screeningTime":"20:00","actors":["Tecla Insolia, Michele Riondino, Fabrizia Sacchi, Andrea Pennacchi, Valentina Bell\xe8 u.a."],"subtitle":["Vergangenheit und Gegenwart, Fleisch und Asche, das Unermessliche und das Winzige: Gianfranco Rosis in Venedig pr\xe4mierter Dokumentarfilm ist eine Studie extremer Kontraste. Vor der Kulisse des aktiven Vulkans sucht er in Knochenwei\xdf und samtigem Schwarz nach den elementaren Geometrien des Lebens."],"bodycopy":["\u201EUnter den grauwei\xdfen Wolken lauert ein Vulkan. Riesige Rauchwolken ziehen \xfcber den Bildschirm und f\xfcllen das Bild mit dampfenden Schn\xf6rkeln, w\xe4hrend gl\xfchend schwarze Lava aus dem Erdinneren hervorquillt. W\xe4hrend im Golf von Neapel reges Treiben herrscht \u2013 die Menschen gehen ihren t\xe4glichen Aufgaben nach, verrichten ihre Arbeit \u2013, befindet sich das Gebiet zugleich in einer Art Schwebezustand, bereit f\xfcr das bevorstehende Unheil. In Gianfranco Rosis SOTTO LE NUVOLE k\xfcndigt der Vulkan eine ganze Reihe weiterer Krisen an. Das Elementare und das Historische sind hier untrennbar miteinander verflochten.\u201C (Sophia Satchell-Baeza)"],"image":"Sotto le nuvole.jpg"},{"title":"PRIMAVERA (VIVALDI UND ICH)","director":"Damiano Michieletto","country":"Italien, Frankreich","releaseYear":2025,"runtime":110,"version":"OmU","screeningDate":"17.12.2026","readableDate":"2026-12-17","screeningTime":"20:00","actors":["Tecla Insolia, Michele Riondino, Fabrizia Sacchi, Andrea Pennacchi, Valentina Bell\xe8 u.a."],"subtitle":["Im Venedig des 18. Jahrhunderts w\xe4chst die talentierte Violinistin Cecilia im Ospedale della Piet\xe0 auf \u2013 einem Heim f\xfcr verwaiste M\xe4dchen, das die dort lebenden Kinder in das Studium der Musik einf\xfchrt und dessen Orchester weltweit angesehen ist. Bei ihren Auftritten f\xfcr wohlhabende G\xf6nner bleibt Cecilia stets hinter einer Maske verborgen: Sie soll nicht als eigenst\xe4ndige Person gesehen werden. Doch mit der Ankunft eines neuen Lehrers bekommt sie erstmals die Chance, der Enge ihres bisherigen Lebens und der Aussicht einer arrangierten Ehe zu entkommen.","Antonio Vivaldi, der neue Leiter des Orchesters, ermutigt sie, ihren eigenen Weg zu gehen."],"bodycopy":["PRIMAVERA erz\xe4hlt eine Geschichte weiblicher Selbstbestimmung, eingebettet in die atmosph\xe4rische Kulisse des barocken Venedigs und getragen von der Musik Antonio Vivaldis. Der Theater und Opernregisseur Damiano Michieletto verwebt in seinem Spielfilmdeb\xfct die Biografie des weltber\xfchmten Komponisten mit dem Schicksal einer jungen Waise, die in der Musik die Inspiration findet, ihr Leben in die eigenen H\xe4nde zu nehmen."],"image":"Primavera.jpg"}]');


// const path = './JSON/programm.json';
// let data = [];
const $f7588e118d01bb94$var$movieContainer = document.querySelector(".movie-container");
// async function getFetchedData() {
//     let data = await fetchData(path);;
//     return data;
// }
// data.push(await getFetchedData());
// let movies = data[0];
$f7588e118d01bb94$var$movieContainer.appendChild((0, $b4xNq.renderMovies)((0, (/*@__PURE__*/$parcel$interopDefault($cdae745ca2b0c37d$exports)))));


//# sourceMappingURL=programm.9dab193f.js.map
